<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://',  v-if='params')
            slot(name='multiplayer')
            template(v-if='!homework  ||  homework.editable  ===  undefined  ||  (homework  &&  (homework.editable  ||  usersIds))')
                .form__field
                    label.form__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_numOfExamples')  }}
                    .form__field-body.form-container__select-examples
                        cs-spin-input(
                            :value="params.amountOfExamples",
                            :max="maxExamples",
                            :min="1",
                            :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)",
                            @increase="increaseExamples",
                            @decrease="decreaseExamples",
                            @input="params.amountOfExamples = $event",
                        )
                        .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                            cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                v-model="params.infinityAmountOfExamples"
                                :checked="params && params.infinityAmountOfExamples"
                                :disabled="params && !!params.dictation"
                            )
                            svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                    .form__field-body
                        cs-multiselect(
                            :options="timeLimitValues",
                            v-model="params.timeLimit"
                            :placeholder="timeLimitLabel(params.timeLimit)"
                            :multiple="false"
                            :custom-label="timeLimitLabel"
                        )
                .form__field.checkbox(v-if="gameMode  ===  'free-game'")
                    label.form__label.checkbox__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_dictation')  }}
                    .form__field-body
                        cs-checkbox(v-model="params.dictation", @change="dictationClicked", :disabled="isMultiplayer")
                .form__field(v-if="params.dictation")
                    label.form__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer')  }}
                    .form__field-body
                        cs-multiselect(
                            :options="amountOfSeconds()",
                            v-model="params.timeForAnswer"
                            :placeholder="secondsLabel(params.timeForAnswer)"
                            :multiple="false"
                            :allow-empty="false"
                            :custom-label="secondsLabel"
                        )
                .form__field.checkbox
                    label.form__label.checkbox__label
                        |  {{ $i18n.t('trainer.trainer_gameFormSetting_showAnswer') }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.showAnswer"
                            :checked="params.showAnswer"
                        )
                .form__field.checkbox
                    label.form__label.checkbox__label
                        |  {{ $i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.changingMultipliers"
                            :checked="params.changingMultipliers"
                        )
            divider
            .row
                .col-md-9.col-xs-12
                    .divisible-multiplier
                        span
                            template(v-if='params.numbers.length  ===  0')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                            template(v-else='')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .form__field_columns.form__field_numbers
                        template(v-for='(number, index) in numbers')
                            cs-checkbox.checkbox-for-numbers(
                                :checked="params.numbers && params.numbers.includes(number)",
                                @change="setNumber(number)"
                                :disabled="params.operations.divide && number === 0"
                            )
                                |   {{ number }}
                    span.help.is-danger(v-show="errors.has('numbers')")
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_select')  }}
                        template(v-if='params.numbers.length  ===  0')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                        template(v-else)
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
                .col-md-3.col-xs-12
                    .divisible-multiplier
                        span.column-name
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_operations')  }}
                    .form__field_operations
                        .form__field-body.multiplication-division
                            cs-checkbox(
                                v-model="params.operations.multiply"
                            )
                                |   {{  $i18n.t('trainer.trainer_gameFormSetting_operationMultiply')  }}
                        .form__field-body.multiplication-division
                            cs-checkbox(
                                v-model='params.operations.divide'
                                @change="onChangeOperationsDivide"
                            )
                                |   {{  $i18n.t('trainer.trainer_gameFormSetting_operationDivide')  }}
                    span.help.is-danger(v-show="errors.has('operations')")
                        |  {{  $i18n.t('trainer.trainer_gameFormErrors_chooseOperation')  }}
            slot(name='parameters')
            .help-slot
                slot(name='help')
            .buttons-containergameMode
                cs-button.button.is-outlined.is-info(type="button", @click='cancel' pattern="primary-outline", color="blue")
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_dontSave')  }}
                cs-button.button.is-info(type="button", @click='validateBeforeSave', color="blue")
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_saveGame')  }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import disableDictationForMultiplayer from '../../../utils/multiplayer/disableDictationForMultiplayer';
    import TrainerGames from '../../../config/trainer';
    import { mapState } from 'vuex';
    import _ from 'lodash';

    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import IntervalConfig from "../../trainer/configs/IntervalConfig";

    export default {
        props: ['gameMode', 'slug', 'courseType', 'id', 'usersIds', 'homeworkId', 'gameId', 'generatorGameIndex'],
        mixins: [GameFormMixin, multiplayerFormMixin, disableDictationForMultiplayer],
        data() {
            return {
                timeLimitValues: IntervalConfig.timeLimitValues,
                maxExamples: 100,
                params: null,
            };
        },
        mounted() {
            if (this.homework && this.homework.courses) {
                let copyCourses = this.homework.courses.filter(course =>
                    course.games.find(element => element.slug == this.slug)
                );
                copyCourses.sort((a, b) => a.level - b.level);
                let currentGameSettings = copyCourses[0].games.find(element => element.slug == this.slug);
                this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
            }
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.params = getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: this.gamesParameters[this.slug],
                        },
                    });
                } else {
                    this.params = _.find(TrainerGames.games, { slug: this.slug }).parameters.default;
                }
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            'params.operations': {
                handler(val) {
                    if (val.multiply || val.divide) {
                        this.$validator.detach('operations');
                    } else {
                        this.$validator.attach('operations', 'required');
                    }
                },
                deep: true,
            },
            'params.operations.divide'(val) {
                if (!val) {
                    this.params.selfDivision = false;
                }
            },
            'params.numbers'(val) {
                if (val.length) {
                    this.$validator.detach('numbers');
                } else {
                    this.$validator.attach('numbers', 'required');
                }
            },
            'params.dictation'(val) {
                if (val) {
                    this.params.infinityAmountOfExamples = false;
                }
            },
        },
        computed: {
            ...mapState({
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            numbers() {
                return Array.from(Array(11), (_, i) => i);
            },
        },
        methods: {
            timeLimitLabel(amount) {
                return !amount
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
            dictationClicked() {
                this.params.timeForAnswer = this.params.dictation ? 1 : '-1';
            },
            validateBeforeSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (this.usersIds) {
                            this.saveGame();
                        } else if (this.gameMode === 'free-game') {
                            this.saveGameMode();
                        } else {
                            this.saveGame();
                        }
                    }
                });
            },
            amountOfSeconds() {
                if (!this.params.dictation) {
                    let array = Array.from(Array(100), (_, i) => i + 1);
                    array.unshift(Number('-1'));
                    return array;
                }
                return Array.from(Array(100), (_, i) => i + 1);
            },
            secondsLabel(amount) {
                if (!this.params.dictation) {
                    return amount == -1
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                        : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                }
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            setNumber(number) {
                if (this.params.numbers.includes(number)) {
                    this.params.numbers.splice(this.params.numbers.indexOf(number), 1);
                } else {
                    this.params.numbers.push(number);
                }
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.examples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
            onChangeOperationsDivide() {
                const zeroIndex = this.params.numbers.indexOf(0);
                if (this.params.operations.divide && zeroIndex > -1) {
                    this.params.numbers.splice(zeroIndex, 1);
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field_columns {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
    }

    .form__field_numbers {
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 0;
    }

    .form__field--column {
        flex-direction: column;
        @include stack-space($space-base);
        align-items: flex-start;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field_operations {
        display: flex;
        @media screen and (max-width: 767px) {
            :first-child {
                flex-grow: 0;
                margin-right: 10px;
            }
        }
        @include media($md) {
            display: block;
        }
    }

    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }

    .col-md-4:first-child {
        @media screen and (min-width: 740px) {
            padding-right: 30px;
        }
        .form__field--column {
            @media screen and (min-width: 768px) and (max-width: 850px) {
                width: 180px;
            }
        }
    }

    .col-md-4:last-child {
        .form__field--column {
            @media screen and (min-width: 768px) and (max-width: 820px) {
                font-size: 14px;
            }
        }
    }

    .checkbox-container {
        display: flex;
        flex-direction: column;
        label {
            padding-bottom: 0 !important;
        }
        @include stack-space($space-base);
    }

    .checkbox-for-numbers {
        margin-right: 15px;
        margin-bottom: $space-small !important;
    }

    .divisible-multiplier {
        margin: 10px 5px;
    }

    .multiplication-division {
        @include stack-space($space-small);
    }

    .select-numeral {
        flex-direction: column;
        align-items: flex-start;
    }

    .select-container__label {
        margin: 10px 0 5px;
    }

    .buttons-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .button.is-info {
        height: 100% !important;
        font-size: $font-size-16;
        &:first-child {
            margin-bottom: 20px;
            @include media($sm) {
                margin: 0 5px;
            }
        }
        @include media($md) {
            font-size: $font-size-16;
            margin: 0 15px;
        }
    }

    .help {
        &.is-danger {
            color: #ff3d53;
        }
    }

    .help-slot {
        text-align: center;
        margin-top: 20px;
    }

    .checkbox {
        @media screen and (max-width: 767px) {
            flex-direction: row;
        }
    }

    .buttons-containergameMode {
        margin-top: 20px;
        display: flex;
        justify-content: center;

        :last-child {
            margin-left: 10px;
        }
    }

    .checkbox__label {
        @media screen and (max-width: 767px) {
            margin-bottom: 0;
            display: flex;
            align-items: center;
        }
    }
</style>
